import {ObjectBuilder} from '@gongxigames/framework/core';
import {MenuBarButtonButtonConfig, MenuBarButton} from '@gongxigames/framework/slot/modules/menubar/ButtonPanel/MenuBarButton';
import {Panel, PanelPosition} from '@gongxigames/framework/slot/modules/menubar/ButtonPanel/Panel';
import {Container} from 'pixi.js';

export type ButtonPanelConfig = {
    width: number;
    buttons: Pick<MenuBarButtonButtonConfig, 'icon' | 'action' | 'active'>[];
};

export class ButtonPanel {
    public readonly container: Container = new Container();

    private _panel: Panel;
    private _buttons: MenuBarButton[] = [];
    private _config?: ButtonPanelConfig;
    private _buttonVerticalPadding = 30;
    private _buttonHorizontalPadding = -30;

    constructor(private readonly _objectBuilder: ObjectBuilder) {
        this._panel ??= new Panel(_objectBuilder);

        this.container.name = 'ButtonPanel';
        this.container.addChild(this._panel.container);
    }

    public update(config: ButtonPanelConfig): void {
        this._config = config;

        const separators = Math.max(config.buttons.length - 1, 0);
        const positions = this._panel.update({
            width: config.width,
            separators,
            buttonVerticalPadding: this._buttonVerticalPadding,
            buttonHorizontalPadding: this._buttonHorizontalPadding
        });

        this.setButtons(positions);
    }

    private setButtons(positions: PanelPosition[]): void {
        const oldButtons = this._buttons;
        const {buttons} = this._config!;

        this._buttons = buttons.map((config, i) => {
            const position = positions[i];
            const button = oldButtons.shift() ?? new MenuBarButton(this._objectBuilder);

            button.update({
                ...config,
                width: position.width,
                height: position.height
            });

            button.container.position.set(position.x, position.y);
            this.container.addChild(button.container);

            return button;
        });

        oldButtons.forEach(button => this.container.removeChild(button.container));
    }
}
